export default __webpack_public_path__ + "static/media/upload-icon.b0ea0ea3.svg";